/* Zoba — tek ürün teması · theme.js */
(function () {
  'use strict';
  var d = document, w = window;
  var reduce = w.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var root = (w.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  /* ---------- veri ---------- */
  var K = {};
  try { K = JSON.parse(d.getElementById('ZobaData').textContent); } catch (e) {}
  var P = K.packs || [];
  var pk = 0;
  var ct = 'nakit';

  function fmt(cents) {
    var v = Math.round(cents / 100);
    return v.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ' ₺';
  }
  function packNow() { return P[pk] || P[0]; }
  function feeObj() { return (K.fees && K.fees[ct] && K.fees[ct].id) ? K.fees[ct] : K.fee; }
  function fee() { var f = feeObj(); return f && f.id ? f.price : 0; }

  function render() {
    var c = packNow(); if (!c) return;
    var fq = c.n || 1, on = c.on.price, cod = c.cod.price + fee() * fq, diff = cod - on;
    d.querySelectorAll('[data-pack]').forEach(function (b) {
      var on_ = +b.getAttribute('data-pack') === pk;
      b.classList.toggle('is-on', on_); b.setAttribute('aria-checked', on_ ? 'true' : 'false');
    });
    d.querySelectorAll('[data-on-total]').forEach(function (e) { e.textContent = fmt(on); });
    d.querySelectorAll('[data-cod-total]').forEach(function (e) { e.textContent = fmt(cod); });
    d.querySelectorAll('[data-save-amt]').forEach(function (e) { e.textContent = fmt(diff); });
    d.querySelectorAll('[data-pack-name]').forEach(function (e) { e.textContent = c.name; });
    d.querySelectorAll('[data-codtype]').forEach(function (b) {
      var on_ = b.getAttribute('data-codtype') === ct;
      b.classList.toggle('is-on', on_); b.setAttribute('aria-checked', on_ ? 'true' : 'false');
    });
    d.querySelectorAll('[data-codtype-name]').forEach(function (e) { e.textContent = ct === 'kart' ? 'kapıda kartla' : 'kapıda nakit'; });
    var s = d.querySelector('[data-sheet]');
    if (s) {
      s.querySelector('[data-s-items]').textContent = fmt(c.cod.price);
      s.querySelector('[data-s-fee]').textContent = fee() ? fmt(fee() * fq) : '0 ₺';
      var fl = s.querySelector('[data-s-feeq]'); if (fl) fl.textContent = fq > 1 ? ' (' + fq + ' × ' + fmt(fee()) + ')' : '';
      s.querySelector('[data-s-total]').textContent = fmt(cod);
      s.querySelector('[data-s-online]').textContent = fmt(on);
      s.querySelector('[data-s-diff]').textContent = fmt(diff);
    }
  }
  function setPack(i) { i = parseInt(i, 10); if (isNaN(i) || !P[i]) i = 0; pk = i; render(); }

  d.addEventListener('click', function (e) {
    var b = e.target.closest('[data-pack]');
    if (b) { e.preventDefault(); setPack(b.getAttribute('data-pack')); return; }
    var t = e.target.closest('[data-codtype]');
    if (t) { e.preventDefault(); ct = t.getAttribute('data-codtype') === 'kart' ? 'kart' : 'nakit'; render(); }
  });
  d.addEventListener('keydown', function (e) {
    var b = e.target.closest && e.target.closest('[data-pack]');
    if (!b || (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft' && e.key !== 'ArrowDown' && e.key !== 'ArrowUp')) return;
    e.preventDefault();
    var n = (pk + ((e.key === 'ArrowRight' || e.key === 'ArrowDown') ? 1 : -1) + P.length) % P.length;
    setPack(n);
    var g = b.parentNode.querySelector('[data-pack="' + n + '"]'); g && g.focus();
  });

  /* ---------- ödeme yönlendirme ---------- */
  function busy(btn) {
    if (!btn) return;
    btn.setAttribute('aria-busy', 'true');
    btn.dataset.label = btn.innerHTML;
    btn.innerHTML = 'Ödeme sayfası açılıyor…';
    setTimeout(function () { if (btn.dataset.label) { btn.innerHTML = btn.dataset.label; btn.removeAttribute('aria-busy'); } }, 6000);
  }
  function goOnline(btn) {
    var c = packNow(); if (!c || !c.on.id) return;
    busy(btn);
    w.location.href = root + 'cart/' + c.on.id + ':1';
  }
  function goCod(btn) {
    var c = packNow(); if (!c || !c.cod.id) return;
    busy(btn);
    var items = c.cod.id + ':1';
    var f = feeObj();
    if (f && f.id) items += ',' + f.id + ':' + (c.n || 1);
    w.location.href = root + 'cart/' + items;
  }

  var sheet = d.querySelector('[data-sheet]');
  function openSheet() {
    render();
    if (sheet && sheet.showModal) { sheet.showModal(); var c = sheet.querySelector('[data-sheet-confirm]'); c && c.focus(); }
    else goCod();
  }
  if (sheet) {
    sheet.addEventListener('click', function (e) {
      if (e.target === sheet || e.target.closest('[data-sheet-close]')) sheet.close();
    });
    sheet.querySelector('[data-sheet-confirm]').addEventListener('click', function () { goCod(this); });
  }
  d.addEventListener('click', function (e) {
    var g = e.target.closest('[data-go]');
    if (!g || g.disabled) return;
    e.preventDefault();
    if (g.getAttribute('data-go') === 'online') {
      if (sheet && sheet.open) sheet.close();
      goOnline(g);
    } else {
      openSheet();
    }
  });
  w.addEventListener('pageshow', function (e) {
    if (e.persisted) d.querySelectorAll('[aria-busy="true"]').forEach(function (b) { if (b.dataset.label) { b.innerHTML = b.dataset.label; b.removeAttribute('aria-busy'); } });
  });
  render();

  /* ---------- başlık, menü, duyuru ---------- */
  var hdr = d.querySelector('[data-header]');
  if (hdr) {
    var hs = function () { hdr.classList.toggle('is-scrolled', w.scrollY > 8); };
    w.addEventListener('scroll', hs, { passive: true }); hs();
  }
  var drawer = d.querySelector('[data-drawer]');
  if (drawer) {
    var last = null;
    var open = function () { last = d.activeElement; drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false'); d.body.style.overflow = 'hidden'; var f = drawer.querySelector('button'); f && f.focus(); };
    var close = function () { drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true'); d.body.style.overflow = ''; last && last.focus(); };
    d.querySelectorAll('[data-drawer-open]').forEach(function (b) { b.addEventListener('click', open); });
    drawer.addEventListener('click', function (e) { if (e.target === drawer || e.target.closest('[data-drawer-close]') || e.target.closest('a')) close(); });
    d.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer.classList.contains('is-open')) close(); });
  }
  d.querySelectorAll('[data-rotate]').forEach(function (bar) {
    var it = bar.querySelectorAll('.ann__item'); if (it.length < 2 || reduce) return;
    var i = 0; setInterval(function () { it[i].classList.remove('is-active'); i = (i + 1) % it.length; it[i].classList.add('is-active'); }, 3200);
  });

  /* ---------- görünür olunca belir ---------- */
  var rv = d.querySelectorAll('.rv');
  if ('IntersectionObserver' in w && !reduce) {
    var io = new IntersectionObserver(function (en) { en.forEach(function (x) { if (x.isIntersecting) { x.target.classList.add('is-in'); io.unobserve(x.target); } }); }, { rootMargin: '0px 0px -8% 0px' });
    rv.forEach(function (el) { io.observe(el); });
  } else rv.forEach(function (el) { el.classList.add('is-in'); });

  /* ---------- galeri ---------- */
  d.querySelectorAll('[data-gallery]').forEach(function (g) {
    var tr = g.querySelector('[data-gal-track]'), sl = g.querySelectorAll('[data-gal-slide]'),
        th = g.querySelectorAll('[data-gal-thumb]'), dots = g.querySelectorAll('.gal__dots span');
    if (!tr || !sl.length) return;
    var set = function (k) {
      th.forEach(function (t, j) { t.setAttribute('aria-current', j === k ? 'true' : 'false'); });
      dots.forEach(function (t, j) { t.classList.toggle('is-on', j === k); });
    };
    th.forEach(function (t, k) { t.addEventListener('click', function () { tr.scrollTo({ left: sl[k].offsetLeft - tr.offsetLeft, behavior: reduce ? 'auto' : 'smooth' }); set(k); }); });
    var tk = false;
    tr.addEventListener('scroll', function () { if (tk) return; tk = true; requestAnimationFrame(function () { set(Math.max(0, Math.min(sl.length - 1, Math.round(tr.scrollLeft / tr.clientWidth)))); tk = false; }); }, { passive: true });
    set(0);
  });

  /* ---------- yapışkan satın al çubuğu ---------- */
  var sbar = d.querySelector('[data-sbar]'), buy = d.getElementById('satin-al');
  if (sbar && buy && 'IntersectionObserver' in w) {
    d.body.classList.add('has-sbar');
    var buyVis = false, heroOut = false, hx = d.querySelector('[data-assemble]');
    var upd = function () { var on = heroOut && !buyVis; sbar.classList.toggle('is-on', on); sbar.setAttribute('aria-hidden', on ? 'false' : 'true'); sbar.querySelector('a').tabIndex = on ? 0 : -1; };
    new IntersectionObserver(function (en) { buyVis = en[0].isIntersecting; upd(); }, { threshold: 0.08 }).observe(buy);
    if (hx) new IntersectionObserver(function (en) { heroOut = !en[0].isIntersecting; upd(); }, { threshold: 0 }).observe(hx.querySelector('.hx__ctas') || hx);
    else { heroOut = true; upd(); }
  }

  /* ---------- tüketim hesaplayıcı ---------- */
  var en = d.querySelector('[data-energy]');
  if (en) {
    var hIn = en.querySelector('[data-en-h]'), pIn = en.querySelector('[data-en-p]');
    var tr2 = function (n, dec) { return n.toLocaleString('tr-TR', { minimumFractionDigits: dec, maximumFractionDigits: dec }); };
    var calc = function () {
      var kw = +(en.querySelector('input[name="en-w"]:checked') || { value: 1 }).value,
          h = +hIn.value, pr = parseFloat(String(pIn.value).replace(',', '.')) || 0;
      en.querySelector('[data-en-hout]').textContent = h + ' saat';
      en.querySelector('[data-en-o1]').textContent = tr2(kw * pr, 2) + ' ₺';
      en.querySelector('[data-en-o2]').textContent = tr2(kw * h * pr, 2) + ' ₺';
      en.querySelector('[data-en-o3]').textContent = tr2(kw * h * pr * 30, 0) + ' ₺';
      en.querySelector('[data-en-o4]').textContent = tr2(kw * h * 30, 0) + ' kWh';
    };
    en.addEventListener('input', calc); en.addEventListener('change', calc); calc();
  }

  /* ---------- montaj animasyonu (84 kare, 7 sprite) ---------- */
  var hx2 = d.querySelector('[data-assemble]');
  if (hx2) {
    if (reduce) { hx2.classList.add('is-static'); return; }
    var n = +hx2.getAttribute('data-frames'), cols = +hx2.getAttribute('data-cols'), rows = +hx2.getAttribute('data-rows'),
        fw = +hx2.getAttribute('data-fw'), fh = +hx2.getAttribute('data-fh'),
        urls = (hx2.getAttribute('data-sprites') || '').split('|').filter(Boolean),
        per = cols * rows, pin = hx2.querySelector('.hx__pin'), cv = hx2.querySelector('.hx__canvas'),
        ctx = cv && cv.getContext('2d'), steps = hx2.querySelectorAll('[data-hx-steps] span');
    if (!n || !urls.length || !ctx) { hx2.classList.add('is-static'); return; }
    var sheets = [], cur = -1, target = 0;
    var ready = function (s) { var im = sheets[s]; return im && im.complete && im.naturalWidth; };
    var draw = function (i) {
      var j = i;
      while (j >= 0 && !ready(Math.floor(j / per))) j--;
      if (j < 0 || j === cur) return;
      var s = Math.floor(j / per), k = j % per, im = sheets[s], sc = im.naturalWidth / (fw * cols);
      ctx.drawImage(im, (k % cols) * fw * sc, Math.floor(k / cols) * fh * sc, fw * sc, fh * sc, 0, 0, cv.width, cv.height);
      cur = j;
    };
    var load = function (s) {
      var im = new Image(); im.decoding = 'async';
      im.onload = function () { if (s === 0) { draw(0); hx2.classList.add('is-ready'); } draw(target); };
      im.src = urls[s]; sheets[s] = im;
    };
    load(0);
    var rest = function () { for (var s = 1; s < urls.length; s++) load(s); };
    if ('requestIdleCallback' in w) requestIdleCallback(rest, { timeout: 1200 }); else setTimeout(rest, 300);
    var tick = false;
    var onS = function () {
      if (tick) return; tick = true;
      requestAnimationFrame(function () {
        var top = parseFloat(getComputedStyle(pin).top) || 0,
            total = hx2.offsetHeight - pin.offsetHeight,
            p = total > 0 ? Math.min(1, Math.max(0, (top - hx2.getBoundingClientRect().top) / total)) : 1;
        hx2.style.setProperty('--hp', p.toFixed(3));
        target = Math.round(p * (n - 1)); draw(target);
        steps.forEach(function (st) { st.classList.toggle('is-on', p >= +st.getAttribute('data-at')); });
        tick = false;
      });
    };
    w.addEventListener('scroll', onS, { passive: true }); w.addEventListener('resize', onS); onS();
  }
})();
